
export default {
  namespaced: true,
  state: {
    selected_menu: 0,
    list: [
      { title: "Users", icon: "/img/users.png", link: "/admin/users" },
      { title: "Guards", icon: "/img/users.png", link: "/admin/guards" },
      { title: "Enterprises", icon: "/img/faqs.png", link: "/admin/enterprises" },
      // { title: "Stores", icon: "/img/faqs.png", link: "/admin/stores" },
      { title: "Sales", icon: "/img/faqs.png", link: "/admin/sales" },
      { title: "Companies", icon: "/img/faqs.png", link: "/admin/companies" },
      { title: "Sponsored brands", icon: "/img/terms.png", link: "/admin/categories" },
      { title: "Coupons", icon: "/img/terms.png", link: "/admin/coupons" },
      { title: "Report", icon: "/img/users.png", link: "/admin/reports" },
      { title: "Insights", icon: "/img/users.png", link: "/admin/insights" },
      { title: "Privacy", icon: "/img/policy.png", link: "/admin/privacies" },
      { title: "Notifications", icon: "/img/faqs.png", link: "/admin/push_notifications/add" },
      { title: "Notification Price", icon: "/img/terms.png", link: "/admin/notification_prices" },
      { title: "Terms", icon: "/img/terms.png", link: "/admin/terms" },
      { title: "Faqs", icon: "/img/faqs.png", link: "/admin/faqs" },
      { title: "Update Password", icon: "/img/users.png", link: "/admin/update-password" },
    ]
  },
  mutations: {
    set_selected_menu(state, selected) {
      state.selected_menu = selected;
    }
  },
  actions: {
    selected_menu({ commit }, selected) {
      commit("set_selected_menu", selected);
    }
  },
  getters: {},
  setters: {},
  modules: {}
};
